import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { VisibilityRounded, VisibilityOffRounded } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { getToken } from "../requests/auth";
import { useCookies } from "react-cookie";
import { COOKIE_SESS } from "../config";
import { useDispatch } from "react-redux";
import { saveSession } from "../store";

export default function Login() {
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const [hidePassword, setHidePassword] = useState(true);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const [cookie, setCookie] = useCookies();
    const dispatch = useDispatch();

    const handleChange = (handler) => (e) => handler(e.target.value);
    const handleShowPassword = (e) => setHidePassword(!hidePassword);

    const handleLogin = async (e) => {
        setLoading(true);

        const r = await getToken({ user, password });

        if (r.status === "ok") {
            const { token, name, user, role } = r.result;
            setCookie(
                COOKIE_SESS,
                { token, name, user, role },
                {
                    path: "/",
                    sameSite: "none",
                    secure: true,
                }
            );
            dispatch(saveSession({ token, name, user, role }));
        } else {
            setError(true);
        }
        setLoading(false);
    };

    useEffect(() => {
        console.log(cookie);
    }, [cookie]);

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div>
                <Card
                    variant="outlined"
                    elevation={0}
                    sx={{
                        p: 2,
                        borderColor: "primary",
                        bgcolor: "rgba(255, 255, 255, 0.9)",
                        backdropFilter: "blur(20px)",
                    }}
                >
                    <CardHeader
                        title="Inicia sesión"
                        subheader="Chat web"
                        titleTypographyProps={{
                            color: "primary",
                        }}
                    />
                    <CardContent
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                        }}
                    >
                        <TextField
                            label="Usuario"
                            onChange={handleChange(setUser)}
                            value={user}
                            variant="outlined"
                        />
                        <TextField
                            label="Contraseña"
                            onChange={handleChange(setPassword)}
                            value={password}
                            variant="outlined"
                            type={hidePassword ? "password" : "text"}
                            InputProps={{
                                endAdornment: (
                                    <IconButton
                                        color="primary"
                                        onClick={handleShowPassword}
                                    >
                                        {hidePassword ? (
                                            <VisibilityRounded />
                                        ) : (
                                            <VisibilityOffRounded />
                                        )}
                                    </IconButton>
                                ),
                            }}
                        />
                        <Button
                            variant="contained"
                            onClick={handleLogin}
                            size="large"
                            sx={{ textTransform: "none", color: "white" }}
                        >
                            Acceder
                        </Button>
                        {error && (
                            <Typography
                                variant="body1"
                                color="error"
                                align="center"
                            >
                                Usuario o contraseña incorrectos
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            </div>
        </Box>
    );
}
